export default "/fonts/vendor/devextreme/dist/css/icons/dxicons.woff2?e4acc9c2c884e566ddc46017efe8b2c1";